export default "__VITE_ASSET__N9rnSsec__"